import { CarouselProvider } from '@eliadmin/core/src/components/ui/carousel-context';
import { Carousel } from '@eliadmin/core/src/components/ui/carousel';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import { Heading } from '../shared/heading';

interface HeadingContainerClasses {
  container?: string;
  heading?: {
    container?: string;
    subtitle?: string;
    title?: string;
  };
}

interface CarouselContainerClasses {
  container?: string;
  carousel?: {
    wrapper?: string;
    container?: string;
    main?: string;
    slide?: string;
  };
}

interface CourseCarouselSectionProps {
  subtitle: string;
  title: string;
  slides: React.ReactNode[];
  className?: {
    section?: string;
    heading_container?: HeadingContainerClasses;
    carousel_container?: CarouselContainerClasses;
  };
  children?: React.ReactNode;
  mobileChildren?: React.ReactNode;
  options?: any;
}

export function CarouselSection({
  subtitle,
  title,
  className,
  slides,
  children,
  mobileChildren,
  options = {},
}: CourseCarouselSectionProps) {
  return (
    <CarouselProvider>
      <section
        className={cn(
          'custom-section',
          'w-full gap-6 pr-0 sm:gap-8 lg:gap-12 xl:gap-16 xl:pr-6',
          className?.section,
        )}
      >
        <div
          className={cn(
            'custom-container',
            'flex items-center justify-center gap-6 pr-6 md:items-end md:justify-between xl:pr-0',
            className?.heading_container?.container,
          )}
        >
          <Heading
            subtitle={subtitle}
            title={title}
            className={{
              container: cn(className?.heading_container?.heading?.container),
              subtitle: cn(className?.heading_container?.heading?.subtitle),
              title: cn(className?.heading_container?.heading?.title),
            }}
          />
          {children}
        </div>
        <div className={cn('custom-container', className?.carousel_container?.container)}>
          <Carousel
            options={options}
            className={{
              wrapper: cn('w-full', className?.carousel_container?.carousel?.wrapper),
              container: cn('w-full', className?.carousel_container?.carousel?.container),
              main: cn('w-full', className?.carousel_container?.carousel?.main),
              slide: cn(className?.carousel_container?.carousel?.slide),
            }}
            slides={slides}
          />
        </div>
        {mobileChildren}
      </section>
    </CarouselProvider>
  );
}
